__turbopack_context__.v({
  "template": "template-module-scss-module__Ziy4NW__template",
  "template__animation": "template-module-scss-module__Ziy4NW__template__animation",
  "template__animation-behavior": "template-module-scss-module__Ziy4NW__template__animation-behavior",
  "template__close-button": "template-module-scss-module__Ziy4NW__template__close-button",
  "template__content": "template-module-scss-module__Ziy4NW__template__content",
  "template__content-body": "template-module-scss-module__Ziy4NW__template__content-body",
  "template__content_customBg": "template-module-scss-module__Ziy4NW__template__content_customBg",
  "template__content_secondary": "template-module-scss-module__Ziy4NW__template__content_secondary",
  "template_align-x-center": "template-module-scss-module__Ziy4NW__template_align-x-center",
  "template_align-x-left": "template-module-scss-module__Ziy4NW__template_align-x-left",
  "template_align-x-right": "template-module-scss-module__Ziy4NW__template_align-x-right",
  "template_align-y-bottom": "template-module-scss-module__Ziy4NW__template_align-y-bottom",
  "template_align-y-center": "template-module-scss-module__Ziy4NW__template_align-y-center",
  "template_align-y-top": "template-module-scss-module__Ziy4NW__template_align-y-top",
  "template_invisible": "template-module-scss-module__Ziy4NW__template_invisible",
  "template_visible": "template-module-scss-module__Ziy4NW__template_visible",
});
